import { Layout } from 'antd'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { Color } from '../../../Common/Color'
import MobilePublicHeader from '../Header/Mobile/MobilePublicHeader'

export default function MobileHeaderLayout () {
  return (
    <Layout>
      <MobilePublicHeader />
      <Layout.Content style={{ overflowY: 'scroll', backgroundColor: Color.white }}>
        <Outlet />
      </Layout.Content>
    </Layout>
  )
}
